import { render, staticRenderFns } from "./viewInquiryList.vue?vue&type=template&id=28d20de0&"
import script from "./viewInquiryList.vue?vue&type=script&lang=js&"
export * from "./viewInquiryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports